import { createGlobalStyle } from "styled-components";

export const Styles = createGlobalStyle`

    @font-face {
        font-family: "Motiva Sans Light";
        src: url("/fonts/Motiva-Sans-Light.ttf") format("truetype");
        font-style: normal;
    }

    @font-face {
        font-family: "Motiva Sans Bold";
        src: url("/fonts/Motiva-Sans-Bold.ttf") format("truetype");
        font-style: normal;
    }

    body,
    html,
    a {
        font-family: Inter, 'Motiva Sans Light', sans-serif;
    }


    body {
        margin:0;
        padding:0;
        border: 0;
        outline: 0;
        /* background: #060910; */
        /* background: rgba(9,9,52,1); */
        background: rgb(8, 8,28);
        overflow-x: hidden;
        color: rgba(209,213,219,1);

    }

    a:hover {
        color: #18216d;
    }

    input,
    textarea {
        color: #222;
        border-radius: 4px;
        border: 0;
        background: rgba(241, 242, 243, 0.8);
        transition: all 0.3s ease-in-out;  
        outline: none;
        width: 100%;  
        padding: 1rem 1.25rem;

        :focus-within {
            background: rgba(241, 242, 243, 1);
            /* background: none; */
            box-shadow: #2e186a 0px 0px 0px 1px;
        }
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        font-family: 'Motiva Sans Bold', serif;
        /* color: #18216d; */
        color: rgba(209,213,219,1);
        font-weight: 900;
        font-size: 56px;
        line-height: 1.18;

        @media only screen and (max-width: 890px) {
          font-size: 47px;
        }
      
        @media only screen and (max-width: 414px) {
          font-size: 35px;
        }
    }

    p {
        /* color: #18216d; */
        /* color: rgba(209,213,219,0.8); */
        color: rgba(209,213,219,1);
        font-size: 21px;        
        line-height: 1.41;

        @media only screen and (max-width: 890px) {
          font-size: 18px;
            line-height: 1.28;
        }
      
        /* @media only screen and (max-width: 414px) {
          font-size: 19px;
        line-height: 1.16;
        } */
    }

    h1 {
        font-weight: 600;
    }

    a {
        text-decoration: none;
        outline: none;
        /* color: #2E186A; */
        color: rgba(209,213,219,1);

        :hover {
            color: rgba(255,255,255,1);
            text-decoration: underline;
            /* color: #2e186a; */
        }
    }
    
    *:focus {
        outline: none;
    }

    .about-block-image svg {
        text-align: center;
    }

    .ant-drawer-body {
        display: flex;
        flex-direction: column;
        text-align: left;
        padding-top: 1.5rem;
        background: rgb(8, 8, 24);

    }

    .ant-drawer-content-wrapper {
        width: 300px !important;
    }

    .starfield-background {
        position: relative;
        width: 100%;
        height: 100%; /* Full height of the viewport */
        overflow: hidden;
        background: none; /* Space background color */
    }

    .star {
        position: absolute;
        background-color: white;
        border-radius: 50%;
        opacity: 0.5;
        animation: dimShine 3s infinite alternate;
    }

    @keyframes dimShine {
    0% {
        opacity: 0.1;
    }
    100% {
        opacity: 0.8;
    }
    }

    :root {
    --swiper-theme-color: #00caff;
    --swiper-pagination-bullet-inactive-color: #818e9e;
}

`;
